export default "__VITE_ASSET__ss5$vGOq__"